import { useSelector } from 'react-redux';
import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { selectWishlists } from '@client/myAccount/wishlists/redux/wishlists/redux';
import { WishlistsType } from 'b2b-common/core/account/api/wishlists';

export const useWishlistsRecord = (): RemoteRecord<WishlistsType> => useSelector(selectWishlists);
